module.exports = __webpack_public_path__ + "img/photosession_2_1.1eac3514.jpg";